export enum BudgetType {
    Training = "training",
    VCA = "vca"
}
